/**
 * The search results dropdown used by header/Search.tsx,
 * displays search auto complete results.
 * Clicking any result row takes the user to the search page for that result.
 */
import React, { Fragment } from 'react';
import styled from 'astroturf/react';

import AutoCompleteResultRow, { SearchResult } from './AutoCompleteResultRow';
import routes from 'js/core_pre_webpack/routes';
import { MIN_AUTOCOMPLETE_LENGTH } from './SearchBar';
import _Container from "AutoCompleteResults-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/SearchBar/AutoCompleteResults.tsx?styleId=Container";
import _ContentWrapper from "AutoCompleteResults-ContentWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/SearchBar/AutoCompleteResults.tsx?styleId=ContentWrapper";
import _ScrollableContent from "AutoCompleteResults-ScrollableContent.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/SearchBar/AutoCompleteResults.tsx?styleId=ScrollableContent";
import _LoadingContainer from "AutoCompleteResults-LoadingContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/SearchBar/AutoCompleteResults.tsx?styleId=LoadingContainer";
import _Row from "AutoCompleteResults-Row.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/SearchBar/AutoCompleteResults.tsx?styleId=Row";
import _ZeroStateContainer from "AutoCompleteResults-ZeroStateContainer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/SearchBar/AutoCompleteResults.tsx?styleId=ZeroStateContainer";
import _ViewAllButton from "AutoCompleteResults-ViewAllButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/SearchBar/AutoCompleteResults.tsx?styleId=ViewAllButton";
import _Spinner from "AutoCompleteResults-Spinner.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/SearchBar/AutoCompleteResults.tsx?styleId=Spinner";


// darkened overlay is z-index 50
const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

export const ContentWrapper = /*#__PURE__*/styled("div", null, {
  displayName: "ContentWrapper",
  styles: _ContentWrapper
});

export const ScrollableContent = /*#__PURE__*/styled("div", null, {
  displayName: "ScrollableContent",
  styles: _ScrollableContent
});

export const LoadingContainer = /*#__PURE__*/styled("div", null, {
  displayName: "LoadingContainer",
  styles: _LoadingContainer
});

export const Row = /*#__PURE__*/styled("div", null, {
  displayName: "Row",
  styles: _Row
});

// DESIGN: small screen sizes
const ZeroStateContainer = /*#__PURE__*/styled("div", null, {
  displayName: "ZeroStateContainer",
  styles: _ZeroStateContainer
});

// DESIGN: weird blue color?
export const ViewAllButton = /*#__PURE__*/styled("button", null, {
  displayName: "ViewAllButton",
  styles: _ViewAllButton
});

export const Spinner = /*#__PURE__*/styled("i", null, {
  displayName: "Spinner",
  styles: _Spinner
});

type Props = {
  show: boolean;
  searchParams: { q: string } & Record<string, string>;
  results: Array<SearchResult>;
  loading: boolean;
  viewAllResults: () => void;
};

const AutoCompleteResults = ({
  show,
  searchParams,
  results,
  loading,
  viewAllResults,
}: Props) => {
  const encodedParams = Object.entries(searchParams).reduce(
    (result, [key, value]) => {
      result[key] = encodeURIComponent(value);
      return result;
    },
    {} as Record<string, string>,
  );

  return (
    <Container show={show}>
      <ContentWrapper>
        {loading ? (
          <LoadingContainer>
            <AutoCompleteResultRow
              type={'Query'}
              display_name={searchParams.q}
              entity_url={routes.search_path(encodedParams)}
            />
            <Row>
              <Spinner className="fa fa-spinner fa-spin" />
              Searching...
            </Row>
          </LoadingContainer>
        ) : results.length === 0 &&
          searchParams.q.length < MIN_AUTOCOMPLETE_LENGTH ? (
          <ZeroStateContainer>
            Type to search for Papers, People,
            <br />
            Research Interests, Universities, Videos, and Courses
          </ZeroStateContainer>
        ) : (
          <Fragment>
            <ScrollableContent>
              <AutoCompleteResultRow
                type={'Query'}
                display_name={searchParams.q}
                entity_url={routes.search_path(encodedParams)}
              />
              {results != null &&
                results.map((result) => (
                  <AutoCompleteResultRow
                    // @ts-expect-error ts-migrate(2339) FIXME: Property 'id' does not exist on type 'SearchResult... Remove this comment to see the full error message
                    key={`${result.type}${result.id}`}
                    {...result}
                  />
                ))}
            </ScrollableContent>
            <ViewAllButton onClick={viewAllResults}>
              View All Results
            </ViewAllButton>
          </Fragment>
        )}
      </ContentWrapper>
    </Container>
  );
};

export default AutoCompleteResults;
